import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import api from "../axiosSetup";
import CustomNavbar from "../CustomNavbar";
import cfg from "../../config";

/**
 * Wer ist fuer welchen Typ zustaendig.
 *
 * Nur die Zuweisung - angelegt werden die Typen und ihre Formulare in der
 * Administration unter "Formulare gestalten". Beides an zwei Stellen
 * anzubieten, hiesse zwei Wege zu pflegen, die auseinanderlaufen koennen.
 */

const authHeader = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
});

const ZRCostumeTypeManagers = () => {
  const [types, setTypes]       = useState([]);
  const [managers, setManagers] = useState([]);
  const [members, setMembers]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  const [selTypeName, setSelTypeName]     = useState("");
  const [selMemberID, setSelMemberID]     = useState("");
  const [managerSaving, setManagerSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [tRes, mRes, mbRes] = await Promise.all([
        api.get("/api/costume-types", authHeader()),
        api.get("/api/costume-type-managers", authHeader()),
        api.get("/api/all-member-zunftrat", authHeader()),
      ]);
      setTypes(tRes.data);
      setManagers(mRes.data);
      setMembers(mbRes.data.filter((m) => m.isCouncil));
    } catch (e) {
      setError("Fehler beim Laden der Daten.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const addManager = async (e) => {
    e.preventDefault();
    if (!selTypeName || !selMemberID) return;
    setManagerSaving(true);
    try {
      await api.post("/api/costume-type-managers", { costumeTypeName: selTypeName, memberID: Number(selMemberID) }, authHeader());
      setSelMemberID("");
      await load();
    } catch {
      setError("Manager konnte nicht hinzugefügt werden.");
    } finally {
      setManagerSaving(false);
    }
  };

  const removeManager = async (id) => {
    try {
      await api.delete(`/api/costume-type-managers/${id}`, authHeader());
      await load();
    } catch {
      setError("Manager konnte nicht entfernt werden.");
    }
  };

  const managersForType = (typeName) =>
    managers.filter((m) => m.costumeTypeName === typeName);

  return (
    <>
      <CustomNavbar />
      <div className="container mt-4">
        <h2>{cfg.costumeTerm}typen &amp; Typ-Manager</h2>
        <p className="text-muted">
          Hier wird festgelegt, wer für welchen Typ zuständig ist. Die Typen selbst und
          ihre Formulare werden in der Administration unter{" "}
          <Link to="/admin-forms">Formulare gestalten</Link> gepflegt.
        </p>

        {error && (
          <div className="alert alert-danger alert-dismissible">
            {error}
            <button type="button" className="btn-close" onClick={() => setError(null)} />
          </div>
        )}

        {/* ── Manager zuweisen ──────────────────────────────────── */}
        <div className="card mb-4">
          <div className="card-header">Manager zuweisen</div>
          <div className="card-body">
            <form className="row g-2" onSubmit={addManager}>
              <div className="col-md-4">
                <select
                  className="form-select"
                  value={selTypeName}
                  onChange={(e) => setSelTypeName(e.target.value)}
                  required
                >
                  <option value="">-- Typ wählen --</option>
                  {types.map((t) => (
                    <option key={t.id} value={t.name}>{t.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <select
                  className="form-select"
                  value={selMemberID}
                  onChange={(e) => setSelMemberID(e.target.value)}
                  required
                >
                  <option value="">-- {cfg.memberTerm} wählen --</option>
                  {members.map((m) => (
                    <option key={m.ID} value={m.ID}>{m.Vorname} {m.Nachname}</option>
                  ))}
                </select>
              </div>
              <div className="col-auto">
                <button type="submit" className="btn btn-success" disabled={managerSaving}>
                  {managerSaving ? "Speichern…" : "Zuweisen"}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* ── Typen-Übersicht ───────────────────────────────────── */}
        {loading ? (
          <div className="text-center my-5">
            <div className="spinner-border" role="status" />
          </div>
        ) : (
          types.length === 0 ? (
            <div className="alert alert-info">
              Noch keine Typen angelegt. Das geht in der Administration unter{" "}
              <Link to="/admin-forms">Formulare gestalten</Link>.
            </div>
          ) : (
            types.map((t) => (
              <div className="card mb-3" key={t.id}>
                <div className="card-header">
                  <strong>{t.name}</strong>
                </div>
                <div className="card-body p-2">
                  <div className="small text-muted mb-1">Verantwortliche</div>
                  {managersForType(t.name).length === 0 ? (
                    <span className="text-muted small">Kein Manager zugewiesen</span>
                  ) : (
                    <table className="table table-sm mb-0">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>E-Mail</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {managersForType(t.name).map((mg) => (
                          <tr key={mg.id}>
                            <td>{mg.firstName} {mg.lastName}</td>
                            <td>{mg.email}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => removeManager(mg.id)}
                              >
                                Entfernen
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            ))
          )
        )}
      </div>
    </>
  );
};

export default ZRCostumeTypeManagers;
